import React from "react";

/*
 * The data exchange between a self-hosted Nzyme cluster and Connect: status reports flow one way, curated data
 * updates the other.
 */
export default function ExchangeDiagram() {

  return (
      <div className="lo-exchange" role="img"
           aria-label="Your Nzyme cluster sends health and status reports to Connect and pulls curated data updates from Connect.">
        <div className="lo-node">
          <span className="lo-node-icon" aria-hidden="true">
            <svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.5">
              <rect x="2.75" y="3" width="14.5" height="5.5" rx="1.5"/>
              <rect x="2.75" y="11.5" width="14.5" height="5.5" rx="1.5"/>
              <circle cx="6" cy="5.75" r="0.9" fill="currentColor" stroke="none"/>
              <circle cx="6" cy="14.25" r="0.9" fill="currentColor" stroke="none"/>
            </svg>
          </span>
          <div>
            <strong>Your Nzyme cluster</strong>
            <small>Self-hosted nodes and taps</small>
          </div>
        </div>

        <div className="lo-lanes" aria-hidden="true">
          <div className="lo-lane">
            <svg viewBox="0 0 16 104">
              <line x1="8" y1="4" x2="8" y2="94"/>
              <path d="M2.5 89 L8 97 L13.5 89"/>
            </svg>
            <span>
              Health and status report
              <small>Non-sensitive metadata only</small>
            </span>
          </div>

          <div className="lo-lane">
            <svg viewBox="0 0 16 104">
              <line x1="8" y1="100" x2="8" y2="10"/>
              <path d="M2.5 15 L8 7 L13.5 15"/>
            </svg>
            <span>
              Curated data update
              <small>Cached locally</small>
            </span>
          </div>
        </div>

        <div className="lo-node">
          <span className="lo-node-icon" aria-hidden="true">
            <img src="/static/img/nzyme-logo.svg" alt="" />
          </span>
          <div>
            <strong>Connect</strong>
            <small>Curated reference data</small>
          </div>
        </div>
      </div>
  )

}
